<template>
    <div class="row scrollable edit-event bg-white ">
        <loading :name="LOADING" class="col">
            <div class="col text-center">
                <h3 class="mt-3">{{$t('pages.admin.EditUser')}}</h3>
                <hr/>
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <form @submit="submit">
                  <formly-form :form="form" :model="model" :fields="fields" ref="edit"/>
                  <div class="text-right m-3">
                      <button class="btn btn-primary" @click="submit">{{ $t('button.Save') }}</button>
                  </div>
                </form>
            </div>
        </loading>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import isLength from 'validator/lib/isLength';
  import isEmail from 'validator/lib/isEmail';
  import validation from '../../utils/preDefinedValidation';
  import { ERROR_MESSAGES, ROUTER_NAMES } from '../../constants';

  export default {
    name: 'EditUser',
    created() {
      this.$wait.start(this.LOADING);
      this.userDetail({
        userId: this.userId
      })
        .then(() => {
          this.$wait.end(this.LOADING);
          this.model = Object.assign(this.model, {
            firstName: this.user.profile.first_name,
            lastName: this.user.profile.last_name,
            phone: this.user.profile.phone.toString(),
            city: this.user.profile.city,
            email: this.user.email,
            isAdmin: this.user.admin,
            isEditor: this.user.editor,
            note: this.user.admin_note,
          });
        });
    },
    data() {
      return {
        LOADING: 'load user detail',
        disabled: false,
        error: '',
        form: {},
        model: {
          email: '',
          isAdmin: false,
          isEditor: false,
          firstName: '',
          lastName: '',
          phone: '',
          city: ''
        },
        fields: [
          {
              key: 'note',
              type: 'mce',
              templateOptions: {
                  label: this.$t('fields.AdminNote'),
                  note: this.$t('admin.userNote')
              }
          },
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Email')
            },
            required: true,
            validators: {
              valid: validation.validEmail
            }
          },
          {
            key: 'firstName',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.FirstName')
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.LastName')
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
            key: 'city',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.City')
            },
            required: true,
            validators: {
              valid: validation.validString
            }
          },
          {
            key: 'phone',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.PhoneNumber')
            },
            required: true,
            validators: {
                valid: validation.validPhone
            }
          },
          {
            key: 'isAdmin',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.IsAdmin')
            },
            required: true,
          },
          {
            key: 'isEditor',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.IsEditor')
            },
            required: true,
          },
        ]
      };
    },
    methods: {
      ...mapActions(['userDetail', 'editUser']),
      submit(e) {
        e.preventDefault();
        this.$refs.edit.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;
            this.editUser({
              ...this.model,
              userId: this.userId
            }).then(() => {
              this.disabled = false;
              this.$router.back();
            }, (e) => {
              this.disabled = false;
              this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
            })
          })
      }
    },
    computed: {
      user() {
        return this.$store.state.admin.usersDetail[this.userId];
      },
      userId() {
        return this.$route.params.userId;
      }
    }
  };
</script>

<style scoped>
</style>
